export default [
    {
        path: '/sheequipment',
        meta: {
            title: "SHE Equipment",
            show: true
        },
        component: () => import(/* webpackChunkName: "sheequipment" */ '../views/admin/page/SHEEquipment/Index'),
        redirect: { name: 'sheequipment.list' },
        children: [
            {
                path: 'list',
                name: 'sheequipment.list',
                meta: {
                    title: "SHE Equipment List",
                    show: true
                },
                component: () => import(/* webpackChunkName: "sheequipment" */ '../views/admin/page/SHEEquipment/EquipmentList'),
            },
            {
                path: 'detail/:model/:id',
                name: 'sheequipment.detail',
                meta: {
                    title: "SHE Equipment Detail",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "sheequipment" */ '../views/admin/page/SHEEquipment/EquipmentDetail'),
            },
        ]
    }
]